import './YoutubeEmbed.css'

interface YoutubeEmbedProps {
  embedVideo: string
  tabIndex?: number
  title?: string
}

export const YoutubeEmbed = ({ embedVideo, tabIndex, title }: YoutubeEmbedProps) => (
  <div className="youtube-embed">
    <iframe
      title={title || 'YouTube video player'}
      className="youtube-embed__iframe"
      tabIndex={tabIndex || 0}
      width="853"
      height="480"
      src={`${embedVideo}?enablejsapi=1&origin=${window.location.origin}`}
    />
  </div>
)
